import AlarmCentralCollectionView from 'scripts/defa/alarm-centrals/view-alarm-central-collection-view';
import ActiveContainer            from 'scripts/poppet/active-container';
import template                   from 'templates/alarmCentralContainer.jst.html';

/**
 * defa.views.AlarmCentralContainer
 * A container for alarm central selection.
 * @version 1.2.0
 */

const selectors = {
	container: '[data-region=selection-container]',
};

const AlarmCentralContainer = ActiveContainer.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card',
	
	regions: {
		container: selectors.container,
	},
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView is selected.
	 * @void
	 */
	onChildviewSelected: function ( childView ) {
		this.selected = childView.model.get( 'id' );
		this.enableSubmit();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches the collection view of radio buttons for selection.
	 * @void
	 */
	attachView: function () {
		let alarmCentralCollectionView = new AlarmCentralCollectionView( {
			collection: this.collection,
		} );
		
		this.showChildView( 'container', alarmCentralCollectionView );
	},
	
	/**
	 * Saves the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'alarmCentral:selected', this.selected );
	},
	
} );


export default AlarmCentralContainer;